var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":_vm.color}}),_c('div',{staticClass:"text-center",class:("text-center " + (!_vm.textColor || _vm.textColor + '--text'))},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }